import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "desktop"]

  connect() {
    this.boundRebuild = () => this.buildMenu()
    this.element.addEventListener("print-selection:updated", this.boundRebuild)
    this.buildMenu()
    this.observer = new MutationObserver(() => this.buildMenu())
    this.observer.observe(this.desktopTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
      attributeFilter: ["disabled", "class", "aria-disabled"]
    })
  }

  disconnect() {
    this.element.removeEventListener("print-selection:updated", this.boundRebuild)
    this.observer?.disconnect()
  }

  buildMenu() {
    this.menuTarget.replaceChildren()

    for (const wrapper of this.desktopTarget.children) {
      const control = this.findControl(wrapper)
      if (!control) continue

      const li = document.createElement("li")
      const item = this.toMenuItem(control, li)
      li.appendChild(item)
      this.menuTarget.appendChild(li)
    }
  }

  isDisabled(control) {
    return (
      control.disabled ||
      control.classList.contains("btn-disabled") ||
      control.getAttribute("aria-disabled") === "true"
    )
  }

  applyDisabledState(item, li) {
    li.classList.add("disabled")
    item.setAttribute("aria-disabled", "true")
    item.classList.add(
      "menu-disabled",
      "opacity-40",
      "pointer-events-none",
      "cursor-not-allowed",
      "text-base-content/40"
    )
    if (item.tagName === "BUTTON") {
      item.disabled = true
    }
  }

  findControl(wrapper) {
    if (wrapper.matches("a, button, label")) return wrapper
    return wrapper.querySelector("a, button, label")
  }

  toMenuItem(control, li) {
    const disabled = this.isDisabled(control)

    if (control.tagName === "LABEL") {
      const label = document.createElement("button")
      label.type = "button"
      label.className = "gap-2"
      label.innerHTML = control.innerHTML
      if (control.classList.contains("btn-primary")) {
        label.classList.add("text-primary")
      }
      if (disabled) {
        this.applyDisabledState(label, li)
      } else {
        label.addEventListener("click", (event) => {
          event.preventDefault()
          control.click()
          this.closeDropdown()
        })
      }
      return label
    }

    const item = document.createElement(control.tagName === "A" ? "a" : "button")
    item.className = "gap-2"
    item.innerHTML = control.innerHTML

    if (control.classList.contains("btn-primary")) {
      item.classList.add("text-primary")
    }

    if (disabled) {
      this.applyDisabledState(item, li)
    }

    if (control.tagName === "A") {
      if (!disabled) {
        item.href = control.href
        if (control.dataset.turboFrame) {
          item.dataset.turboFrame = control.dataset.turboFrame
        }
        item.addEventListener("click", () => this.closeDropdown())
      }
      return item
    }

    item.type = "button"
    if (!disabled) {
      item.addEventListener("click", (event) => {
        event.preventDefault()
        control.click()
        this.closeDropdown()
      })
    }

    return item
  }

  closeDropdown() {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur()
    }
  }
}
